import { render, staticRenderFns } from "./chargeDescEdit.vue?vue&type=template&id=03555f38&"
import script from "./chargeDescEdit.vue?vue&type=script&lang=js&"
export * from "./chargeDescEdit.vue?vue&type=script&lang=js&"
import style0 from "./chargeDescEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports